import clsx from 'clsx';
import { Link } from 'react-router-dom';
import UserRoleDisplay from '@/components/ui/UserRoleDisplay';
import { useAuthStore } from '@/stores/authStore';
import { isBorrower } from '@/utils/user';

type NavbarLogoProps = {
  className?: string;
};

export default function NavbarLogo({ className = '' }: NavbarLogoProps) {
  const { user, isAuthenticated } = useAuthStore();
  const isUserBorrower = isBorrower(user);

  const navLink = isAuthenticated ? '/pools' : '/';

  return (
    <Link to={navLink} className={clsx('flex items-center gap-2 cursor-pointer', className)}>
      <img src="/equipool_logo.svg" alt="EquiPool Logo" className="w-[117px] h-[36px]" />
      {isAuthenticated && <UserRoleDisplay isBorrower={isUserBorrower} />}
    </Link>
  );
}
